module.exports = __webpack_public_path__ + "static/media/Artboard17.5eac77ed.png";